import React from 'react';
import './StickyHeader.scss';

const StickyHeader = ({ children }) => (
    <React.Fragment>
        <div className="header fixed">
            <div className="content">
                <div className="children">{children}</div>
            </div>
        </div>
    </React.Fragment>
);

export default StickyHeader;



// WEBPACK FOOTER //
// ./src/components/StickyHeader/StickyHeader.jsx